import React, { Component } from 'react';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
const FileDownload = require('js-file-download');

class DownloadBatch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			batchInEdit: this.props.dataItem || null,
			showMessage: false,
			Message: '',

		};
	}

	handleSubmit = (event) => {

	};
	DownloadBatchReport = (BatchJobId) => {
		var that = this;
        axios.get(`${ROOT_API_URL}/ManageBatches/GetBatchJobDocument?BatchJobId=${BatchJobId}`, { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Batch-report.csv');
			}).catch(function (error) {
				that.setState({
					showMessage: true, Message: 'This file could not be found in storage.'
				});
			});
    }
	closeMessage = () => {
		this.setState({ showMessage: false });
	}

	render() {
		return (
			<div className="batchForm">
				<h2>Download Batch</h2>
				<br />
				{console.log(this.state.batchInEdit,"this.state.batchInEdit")}
				{this.state.batchInEdit.BatchStatus !== "Processed" ?
				<span>Batch has not been processed yet. Download is not available.</span>:
				<span>Batch has been processed. Download is available.</span>
				}
				<br />
				<br />
				<div className="footer col-md-12 edit-cmt-btns">
					<div className="form-group">
						<button className="admin-k-button" onClick={this.props.cancel}>
							<i className="fas fa-times"></i>
							<span> CANCEL</span>
						</button>
						<button
							className="admin-k-button"
							onClick={() => this.DownloadBatchReport(this.state.batchInEdit.BatchJobId)}
							disabled={this.state.batchInEdit.BatchStatus !== "Processed" ?true:false}
						>
							<span> DOWNLOAD</span>
						</button>					
					</div>
				</div>
				<div>
					{this.state.showMessage ?
						<div className='showMessageContainer'>
							<div className='showMessagePopup'>
								<div className='showMessageText'>{this.state.Message}</div>
								<button onClick={this.closeMessage}>ok</button>
							</div>
						</div>
						: ""
					}
				</div>
			</div>
		);
	}
}

export default DownloadBatch;